import { Box } from '@bechtel/gds';
import styled from 'styled-components';

export const NotAuthorizedContainer = styled(Box).attrs({
 // alignItems: { sm: 'center' },
  justifyContent: {
    sm: 'center',
  },
})`
  width: 100%;
  height: 100vh;
  backgroud-color:${({theme})=>theme.colors.grey[100]};
`;
